var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c(
      "div",
      {
        class: _vm.wrapClass === "SDC" ? "landing_wrap" : "",
        attrs: { id: "wrap" }
      },
      [
        _vm.isRouterAlive
          ? _c("skp-gnb", {
              ref: _vm.gnbId,
              on: {
                "router-reload": function($event) {
                  return _vm.routerReload()
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isRouterAlive
          ? _c("router-view", {
              key: _vm.$route.fullPath,
              on: { changeWrapClass: _vm.changeWrapClass }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "keep-alive",
          [
            _vm.isRouterAlive
              ? _c("skp-footer", {
                  on: {
                    "router-reload": function($event) {
                      return _vm.routerReload()
                    }
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("keep-alive", [_c("recommend-pop")], 1)
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "goto_top" }, [
      _c(
        "a",
        { staticClass: "scroll_top_btn", attrs: { href: "javascript:" } },
        [_c("span", { staticClass: "sr_only" }, [_vm._v("TOP")])]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-789fcb0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-789fcb0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/main/SKPMain.vue
// module id = Id2n
// module chunks = 0